module.exports = {
  props: ['image', 'order', 'members'],

  data () {
    return {
      member: null,
      activeItem: 3,
      left: 0,
      items: [],
      key: 0,

      timer: null,

      slideWidth: 79
    }
  },

  mounted () {
    this.setActiveItem()

    if (!this.order.member) {
      this.member = this.items[this.activeItem]

      this.$emit('set-member', this.member)
    } else {
      const index = this.members.findIndex((item => item.id === this.order.member.id))

      this.init(index)

      window.onresize = () => {
        clearTimeout(this.timer)

        this.timer = setTimeout(() => {
          this.setActiveItem()
          const index = this.members.findIndex((item => item.id === this.order.member.id))

          this.init(index)
        }, 100)
      }
    }

    this.items = this.members
  },

  methods: {
    setActiveItem () {
      const calcIndex = Math.ceil(this.members.length / 2 - 1)

      if (window.innerWidth < 576) {
        this.activeItem = this.members.length < 3 ? calcIndex : 1
      } else if (window.innerWidth < 768) {
        this.activeItem = this.members.length < 5 ? calcIndex : 2
      } else {
        this.activeItem = this.members.length < 7 ? calcIndex : 3
      }
    },

    init (index) {
      this.shiftSlide(index - this.activeItem)
    },

    prev () {
      this.shiftSlide(-1)
    },

    next () {
      this.shiftSlide(1)
    },

    shiftSlide (direction) {
      const carousel = this.$refs.carousel

      if (carousel.classList.contains('transition')) return

      carousel.classList.add('transition')
      carousel.style = `transform: translateX(${-direction * this.slideWidth}px)`

      setTimeout(() => {
        for (var i = 0; i < Math.abs(direction); i++) {
          if (direction < 0) {
            this.items.unshift(this.items[this.items.length - 1])
            this.items.pop(this.items[this.items.length - 1])
          } else {
            this.items.push(this.items[0])
            this.items.shift(this.items[0])
          }
        }
        this.member = this.items[this.activeItem]

        this.$emit('set-member', this.member)

        carousel.classList.remove('transition')
        carousel.style = 'transform: translateX(0px)'
      }, 400)
    }
  },

  template: `
    <div class="star w-100">
      <div class="d-flex justify-content-center align-items-center w-100">
        <div class="star__image-wrapper w-100">
          <div class="relative w-100 h-100">
            <transition name="fade">
              <div :key="key" class="d-inline-block relative w-100 h-100">
                <div class="star__name-wrapper" :style="'border-color:' + order.member.team_color">
                  <span class="star__name" :style="'background-color:' + order.member.team_color">{{ order.member.f_name }} {{ order.member.l_name }}</span>
                </div>
                <img :src="order.member.image" class="star__image" alt="member">
                <img :src="image" class="star__character" alt="star">
              </div>
            </transition>
          </div>
        </div>
      </div>

      <div class="hero__divider"></div>

      <div class="d-flex justify-content-center align-items-center star__carousel">
        <div @click="prev" class="mr-2 mr-md-4 h-pointer"><img src="/static/personal_book_app/img/hero/navigate/l_dark.svg" alt="left"></div>
        <div class="star__carousel-wrapper">
          <div ref="carousel" class="star__carousel-items">
            <div
              @click="init(index)"
              v-for="(item, index) in items"
              :key="item.id"
              class="ml-2 mr-1 h-pointer star__carousel-item d-inline-block"
              :class="{ 'star__active-item': index === activeItem }"
            >
              <div class="d-flex align-items-center h-100">
                <img :class="index === activeItem ? 'h-opacity-1' : 'opacity-50'" :src="item.team_logo" >
              </div>
            </div>
          </div>
        </div>
        <div @click="next" class="h-pointer ml-2 ml-md-4"><img src="/static/personal_book_app/img/hero/navigate/r_dark.svg" alt="right"></div>
      </div>
    </div>
  `
}
